export default "__VITE_ASSET__DODlyq3V__"